import {
  Component, EventEmitter, Input,
  Output, OnInit, AfterViewInit,
} from '@angular/core';
import * as $ from 'jquery';
import { PanelBodyDirective } from '../../directives/panel-body.directive';
import { PanelFooterDirective } from '../../directives/panel-footer.directive';
import { PanelToolsDirective } from '../../directives/panel-tools.directive';
@Component({
  selector: 'app-advisorop-panel',
  templateUrl: './advisorop-panel.component.html',
  styleUrls: ['./advisorop-panel.component.css'],
})
export class AdvisoropPanelComponent implements OnInit, AfterViewInit {
  @Input() panelTitle!: string;
  @Input() panelTitleBold!: string;
  @Input() showFooter: boolean = false;
  @Input() loadingPanelId!: string;
  @Output() iAmReady = new EventEmitter<any>();

  isLoadingPanelVisible: boolean = false;

  ngOnInit(): void {
    // Emit readiness event
    this.iAmReady.emit(this);
  }

  ngAfterViewInit(): void {
    // Initialize loading panel after view init
    if (this.loadingPanelId) {
      this.initLoadingPanel();
    }
  }

  initLoadingPanel(): void {
    // Mock loading panel options initialization logic
    console.log(`Initializing loading panel with ID: ${this.loadingPanelId}`);
  }

  showLoadingPanel(): void {
    this.isLoadingPanelVisible = true;
    console.log(`Loading panel shown: ${this.loadingPanelId}`);
  }

  hideLoadingPanel(): void {
    this.isLoadingPanelVisible = false;
    console.log(`Loading panel hidden: ${this.loadingPanelId}`);
  }

  showHidePanel(event: Event): void {
    event.preventDefault();

    const el = $(event.currentTarget as HTMLElement || event.target as HTMLElement);
    const hpanel = el.closest('div.hpanel');
    const icon = el.find('i:first');
    const body = hpanel.find('div.panel-body');
    const footer = hpanel.find('div.panel-footer');

    body.slideToggle(300);
    footer.slideToggle(200);

    // Toggle icon from up to down
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    hpanel.toggleClass('').toggleClass('panel-collapse');

    setTimeout(() => {
      hpanel.resize();
      hpanel.find('[id^=map-]').resize();
    }, 50);
  }
}
